import React, { useRef } from "react";
import "./PolicyStudioUploadFileButton.css";
import { toast } from "react-hot-toast";
import { toastFail } from "../../../config";
interface PolicyStudioUploadFileButtonProps {
  label: string;
  variant?: "primary" | "secondary" | "tertiary";
  onFileSelect?: (file: File) => void;
  disabled?: boolean;
}

const MAX_FILE_UPLOAD_SIZE = 10485760;

const ACCEPTABLE_FILES =
  "application/pdf, " +
  "application/msword, " +
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document, " +
  "text/plain, " +
  "text/markdown, ";

const PolicyStudioUploadFileButton: React.FC<
  PolicyStudioUploadFileButtonProps
> = ({ label, variant = "secondary", onFileSelect, disabled }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (event: any) => {
    for (let i = 0; i < event.target.files.length; i++) {
      if (event.target.files[i].size > MAX_FILE_UPLOAD_SIZE) {
        toast("File is too big! Please keep it under 10MB", toastFail);
        return;
      }
    }

    const file = event.target.files?.[0];
    if (file && onFileSelect) {
      onFileSelect(file);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <div
      className={`policy-studio-upload-button policy-studio-upload-button-${variant}`}>
      <button type="button" disabled={disabled}>
        {label}
      </button>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept={ACCEPTABLE_FILES}
        disabled={disabled}
        multiple={false}
        aria-label={label}
      />
    </div>
  );
};

export default PolicyStudioUploadFileButton;
